<script>
export default {
    name: "ApiLogs",
    data() {
        return {
            tableBusy: false,
            tableData: [],
            modalTitle: "",
            totalRows: 1,
            currentPage: 1,
            perPage: 10,
            pageOptions: [10, 25, 50, 100],
            filter: null,
            filterOn: [],
            sortBy: "dateWTime",
            sortDesc: false,
            fields: [
                {
                    key: "dateWTime",
                    sortable: true,
                    label: "Date",
                    thStyle: { width: "250px" },
                },
                {
                    key: "applicationUser.completeName",
                    sortable: true,
                    label: "User",
                    thStyle: { width: "350px" },
                },
                {
                    key: "remarks",
                    sortable: true,
                },
            ],
        };
    },
    computed: {
        rows() {
            return this.tableData.length;
        },
    },
    methods: {
        onFiltered(filteredItems) {
            this.totalRows = filteredItems.length;
            this.currentPage = 1;
        },
        hideModal() {
            this.$bvModal.hide("api-resoure-log-modal");
        },
        getData(id) {
            this.tableBusy = true;
            this.$store
                .dispatch("api/GetApiLogs", id)
                .then((res) => {
                    res.data.forEach((item) => {
                        item.dateWTime = this.formatDateWithTime(
                            new Date(item.logDate)
                        );
                        item.splitted = item.dateWTime.split(" at ");
                    });
                    this.tableData = res.data;
                    this.tableBusy = false;
                })
                .catch((err) => {
                    this.showToast("Something went wrong!", "error");
                });
        },
    },
};
</script>

<template>
    <b-modal
        id="api-log-modal"
        title="API Logs"
        size="lg"
        title-class="font-18"
        hide-footer
        no-close-on-backdrop
        no-close-on-esc
    >
        <div class="d-flex justify-content-center">
            <ul class="verti-timeline list-unstyled">
                <li class="event-list" v-for="(x, xIndex) in tableData" :key="x.id" :class="{'active': xIndex == 0}">
                    <div class="event-timeline-dot">
                        <i class="bx bx-right-arrow-circle font-size-18" :class="{'bx-fade-right': xIndex == 0}"></i>
                    </div>
                    <div class="media">
                        <div class="me-3">
                            <h5 class="font-size-14 mb-0">
                                {{x.splitted[0]}}
                                <i
                                    class="
                                        bx bx-right-arrow-alt
                                        font-size-16
                                        text-primary
                                        align-middle
                                        ms-2
                                    "
                                ></i>
                            </h5>
                            <small>{{x.splitted[1]}}</small>
                        </div>
                        <div class="media-body">
                            <div class="mb-0" style="line-height:14px;">{{x.remarks}}</div>
                            <div><small>({{x.applicationUser.completeName.trim()}})</small></div>
                        </div>
                    </div>
                </li>
            </ul>
        </div>
    </b-modal>
</template>